import { makeSingleton } from '@encodable/registry';
import NumberFormatterRegistry from './NumberFormatterRegistry';
import { NumberFormatInput } from '../types';

export const getNumberFormatterRegistry = makeSingleton(
  () =>
    new NumberFormatterRegistry({
      globalId: '@encodable/format:NumberFormatterRegistry',
    }),
);

export function getNumberFormatter(format?: string) {
  return getNumberFormatterRegistry().get(format);
}

export function formatNumber(format: string | undefined, value: NumberFormatInput) {
  return getNumberFormatterRegistry().format(format, value);
}

export { NumberFormatterRegistry };
export { default as NumberFormats } from './NumberFormats';
export { default as createNumberFormatter } from './createNumberFormatter';
export { default as previewNumber } from './previewNumber';
export { default as createD3NumberFormatter } from './factories/createD3NumberFormatter';
export { default as createSmartNumberFormatter } from './factories/createSmartNumberFormatter';
